module.exports = "//img1.rrcimg.com/_next/static/src/assets/hz_1ImH_.png";